import React, { useContext } from "react";
import { Affix, Button, Space, Popconfirm } from "antd";
import {
  EditOutlined,
  SaveOutlined,
  CloseOutlined,
  DeleteOutlined,
  SendOutlined,
} from "@ant-design/icons";
import { EmployeeDetails } from "../../../serviceoperation/entity/EmployeeOperationEntity";
import { AuthenticationContext } from "../../../contexts/authentication-context";
import { CompanyContext } from "../../../contexts/company-context";

interface Props {
  isEditing: boolean;
  isSaving: boolean;
  resendingInvite: boolean;
  setIsEditing: (v: boolean) => void;
  handleSave: () => Promise<void> | void;
  handleCancel: () => void;
  handleDelete: () => void;
  employee: EmployeeDetails | null;
  handleResendInvite: () => Promise<void> | void;
}

const DrawerActions: React.FC<Props> = ({
  isEditing,
  isSaving,
  resendingInvite,
  setIsEditing,
  handleSave,
  handleCancel,
  handleDelete,
  employee,
  handleResendInvite,
}) => {
  const userInfo = useContext(AuthenticationContext)?.userInfo;
  const { selectedCompany } = useContext(CompanyContext);

  return (
    <Affix offsetTop={0}>
      <div>
        {isEditing ? (
          <Space style={{ width: "100%", justifyContent: "flex-end" }}>
            <Button icon={<CloseOutlined />} onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              type="primary"
              icon={<SaveOutlined />}
              loading={isSaving}
              onClick={handleSave}
            >
              Save Changes
            </Button>
          </Space>
        ) : employee?.isActive &&
          //!employee?.invitePending &&
          userInfo?.employeeCorporation?.find(
            (y) => y.corporationId === selectedCompany!.corporationId
          )?.employeeId !== employee?.employeeId ? (
          <Space style={{ width: "100%", justifyContent: "space-between" }}>
            <div>
              {employee?.invitePending && (
                <Button
                  icon={<SendOutlined />}
                  onClick={handleResendInvite}
                  loading={resendingInvite}
                >
                  Resend Invite
                </Button>
              )}
            </div>

            <Space>
              <Button
                icon={<EditOutlined />}
                onClick={() => setIsEditing(true)}
              >
                Edit
              </Button>

              <Popconfirm
                title={`Delete ${employee?.firstName} ${employee?.lastName}?`}
                onConfirm={handleDelete}
                okText="Delete"
                cancelText="Cancel"
              >
                <Button danger icon={<DeleteOutlined />}>
                  Delete
                </Button>
              </Popconfirm>
            </Space>
          </Space>
        ) : (
          <></>
        )}
      </div>
    </Affix>
  );
};

export default DrawerActions;
